import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
    TipiCodArtResponse,
    AziendaResponse,
    ImballoResponse,
    TipiImageDocRequest,
    TipiImageDocResponse,
} from './impostazioniSlice'

export const impostazioniApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT + '/impostazioni' }),
    reducerPath: 'impostazioniApi',
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getAziende: build.query<AziendaResponse, void>({
            query: () => `list_aziende`,
        }),
        getImballi: build.query<ImballoResponse, void>({
            query: () => `list_imballi`,
        }),
        getTipiImageDoc: build.query<TipiImageDocResponse, TipiImageDocRequest>({
            query: ({ tipoImage }) => `list_tipi_image_doc?tipoImage=${tipoImage}`,
        }),
        getTipiCodArt: build.query<TipiCodArtResponse, void>({
            query: () => `list_tipi_art_codici`,
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAziendeQuery, useGetImballiQuery, useGetTipiImageDocQuery, useGetTipiCodArtQuery } =
    impostazioniApi
